
/*
 * ROSCIOLI OLIVE OIL CLUB
 * Maximum 1 ceramic cruet per olive oil box.
 *
 * Supports One-Time and Annual Subscription.
 * Runs only on the Shopify cart page.
 */

(() => {
  'use strict';

  if (window.__roscioliCruetLimitInstalled) return;

  const root = window.Shopify?.routes?.root || '/';

  const normalizedCartPath =
    (root + 'cart').replace(/\/+$/, '');

  const currentPath =
    window.location.pathname.replace(/\/+$/, '');

  // Do not interfere with product pages.
  if (currentPath !== normalizedCartPath) return;

  window.__roscioliCruetLimitInstalled = true;

  const BOX_ID = 11749700272396;
  const CRUET_ID = 16570151371020;

  const originalFetch = window.fetch.bind(window);

  let timer = null;
  let running = false;
  let pending = false;
  let refreshing = false;

  async function readCart() {
    const response = await originalFetch(root + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to read cart');
    }

    return response.json();
  }

  function countBoxes(cart) {
    return cart.items
      .filter(item =>
        Number(item.product_id) === BOX_ID
      )
      .reduce(
        (total, item) => total + item.quantity,
        0
      );
  }

  async function updateLine(key, quantity) {
    const response = await originalFetch(
      root + 'cart/change.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      }
    );

    if (!response.ok) {
      throw new Error('Unable to adjust cruet quantity');
    }

    return response.json();
  }

  async function validateCart() {
    if (refreshing) return;

    if (running) {
      pending = true;
      return;
    }

    running = true;
    let corrected = false;

    try {
      const cart = await readCart();

      // One cruet allowed per box,
      // regardless of purchase option.
      let remaining = countBoxes(cart);

      for (const item of cart.items) {
        if (Number(item.product_id) !== CRUET_ID) {
          continue;
        }

        const allowed = Math.max(
          0,
          Math.min(item.quantity, remaining)
        );

        remaining -= allowed;

        if (item.quantity > allowed) {
          await updateLine(item.key, allowed);
          corrected = true;
        }
      }

      if (corrected) {
        refreshing = true;

        // Refresh only after a real correction.
        window.location.reload();
      }

    } catch (error) {
      console.error(
        '[Roscioli Cruet Limit]',
        error
      );
    } finally {
      running = false;

      if (pending && !refreshing) {
        pending = false;
        scheduleValidation();
      } else {
        pending = false;
      }
    }
  }

  function scheduleValidation() {
    if (refreshing) return;

    clearTimeout(timer);

    timer = setTimeout(() => {
      validateCart();
    }, 900);
  }

  // Monitor Ajax cart updates only on cart page.
  window.fetch = function(...args) {
    const result = originalFetch(...args);

    const request = args[0];

    const url = String(
      typeof request === 'string'
        ? request
        : request?.url || ''
    );

    if (
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)
    ) {
      result.then(response => {
        if (response.ok) {
          scheduleValidation();
        }
      }).catch(() => {});
    }

    return result;
  };

  // Validate when the cart page is ready.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleValidation,
      { once: true }
    );
  } else {
    scheduleValidation();
  }

  // Also monitor quantity inputs.
  document.addEventListener('change', event => {
    if (
      event.target.matches(
        'input[name="updates[]"], input[name="quantity"]'
      )
    ) {
      setTimeout(scheduleValidation, 700);
    }
  });

})();
